import { Typography } from '@mui/material'
import { Box, BoxProps } from '@mui/system'
import BigNumber from 'bignumber.js'
import { LiqRatio, SafeLiqRatio } from 'constants/constants'
import { ZERO } from 'constants/number'
import CoreProgressBar from 'core/CoreProgressBar'
import { useResponsive } from 'hooks/useResponsive'
import { toA } from 'utils/display'

interface Props {
  RiskRatio?: BigNumber
  title?: string
  sx?: BoxProps
  showFullText?: boolean
}
const RiskRatioBar = ({ RiskRatio = ZERO, title, sx, showFullText }: Props) => {
  const { isMobile } = useResponsive()
  const labelValue = ((RiskRatio.toNumber() / 100) * LiqRatio).toFixed(2)

  return (
    <Box sx={sx}>
      {title && (
        <Typography variant="body2" mb="-32px">
          {title}
        </Typography>
      )}
      <CoreProgressBar
        ratio={RiskRatio.toNumber()}
        label={`${toA(labelValue)}%`}
        stepLabel={[
          {
            label: isMobile ? 'safe' : `safe ${SafeLiqRatio}%`,
            ratio: (SafeLiqRatio / LiqRatio) * 100,
          },
          {
            label: isMobile
              ? 'liq'
              : showFullText
              ? 'liquidation'
              : `liq ${LiqRatio}%`,
            ratio: 100,
          },
        ]}
      />
    </Box>
  )
}

export default RiskRatioBar
